import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { getAvailableCourses } from '../../../../backend-api';
import { t } from '../../../../i18n';
import { logError } from '../../../../utilities/log';
import { scribbleShineLeftImage } from '../../../assets';
import CoursesCarousel from '../../../components/courses-carousel';
import getCampaignPromocode from '../../../getCampaignPromocode';
import SectionHeader from '../section-header';
import './styles.scss';

const GiftCardCoursesCarousel = () => {
  const [courses, setCourses] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      setError(false);
      try {
        const promocode = getCampaignPromocode();
        const { courses } = await getAvailableCourses({ signal: abortController.signal, promocode });
        setCourses(courses);
      } catch (e) {
        if (abortController.signal.aborted) {
          return;
        }
        setError(true);
        logError('GiftCardCoursesCarousel', 'Error loading courses', { message: e.message });
      }
    };
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  if (error) {
    return null;
  }

  return (
    <Container className="gift-card-courses-carousel">
      <div className="gift-card-courses-carousel__header">
        <SectionHeader className="gift-card-courses-carousel__header-text">
          {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.POPULAR_COURSES')}
          <img src={scribbleShineLeftImage} alt="Shine" className="gift-card-courses-carousel__header-scribble" />
        </SectionHeader>
      </div>
      <CoursesCarousel courses={courses} isLoading={!courses} className="gift-card-courses-carousel__carousel" />
    </Container>
  );
};

export default GiftCardCoursesCarousel;
